import { ChatBotHistoryPage } from '@/Workspaces/ChatBotHistory/Index'
import { createFileRoute, useParams } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/botProvider/$botProviderId/history',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { workspaceId, botProviderId } = useParams({ from: "/workspace/$workspaceId/botProvider/$botProviderId/history" })
  return <ChatBotHistoryPage workspaceId={workspaceId} botProviderId={botProviderId} />
}

